<template>
  <div id="page-wrap" v-if="loggedIn">Success</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TransactionStatus",
  computed: {
    ...mapGetters(["loggedIn"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TransactionStatus.vue